<template>
    <div id="securityInformationClient">
        <div class="container">
            <div class="row m-0 pl-md-5 pr-md-5">
                <div class="col-lg-6 text-left pb-5">
                    <h1 class="pt-5 pb-5">Altijd een veiligheids-professional die bij jouw klus past.</h1>
                    <p class="mb-5">Maak een opdracht, zoek een <router-link tag="a" :to="{ name: 'InformationSecurity'}">beveiliger</router-link>, brandwachten, <router-link tag="a" :to="{ name: 'InformationTrafficSupport'}">verkeersregelaar</router-link> of <router-link tag="a" :to="{ name: 'InformationFirstAid'}">EHBO-er</router-link> voor uw <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'evenementenbeveiliging'}}">evenement</router-link>, <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'objectbeveiliging'}}">pand</router-link> of een ander project en relax. Altijd een veilig gevoel met Azurity.</p>
                    <router-link :to="{ name: 'RegisterClient' }" tag="button" class="btn btn-outline-azure btn-half mb-3">
                        <span>Aanmelden als <br /> opdrachtgever</span>
                        <div class="btn-icon">
                            <span>&rarr;</span>
                        </div>
                    </router-link>
                </div>
                <div class="col-lg-6 pl-md-5 pr-md-5text-center mb-5">
                    <img src="@/assets/guard-600.webp" class="img-fluid" alt="Azurity Beveiliging" />
                </div>
            </div>
        </div>
        <div class="row bg-azure-light m-0 p-5 down light zIndexOne">
            <div class="col-md-4 text-center vert-center  order-md-2 mt-5 mb-5 mt-md-0 mb-md-0">
                <font-awesome-icon icon="binoculars" size="7x"  />
            </div>
            <div class="col-md-4 offset-md-2 text-left  order-md-1">
                <h3>Screening</h3>
                <p>Elke veiligheidsprofessional op ons platform wordt zorgvuldig gescreend. U kunt er vanuit gaan dat de professional over de juiste papieren en kennis beschikt.</p>
            </div>
        </div>
        <div class="row m-0 p-5 down white zIndexThree ">
            <div class="col-md-4 offset-md-2 text-center vert-center  mt-5 mb-5 mt-md-0 mb-md-0">
                <font-awesome-icon :icon="['far', 'comment']" size="7x"  />
            </div>
            <div class="col-md-4 text-left">
                <h3>Direct Contact</h3>
                <p>Wanneer de veiligheidsprofessional uw opdracht heeft geaccepteerd, komt u direct met elkaar in contact.</p>
            </div>
        </div>
        <div class="row bg-azure-light down light m-0 p-5 zIndexTwo">
            <div class="col-md-4 text-center vert-center order-md-2 mt-5 mb-5 mt-md-0 mb-md-0">
                <img class="img img-thumbnail img-hover" src="@/assets/Azurity_Search_Blur_600.webp" width="200" />
            </div>
            <div class="col-md-4 offset-md-2 text-left order-md-1">
                <h3>Slim zoeken</h3>
                <p>Met onze slimme zoek-tool weet je direct wie er met specifieke vaardigheden beschikbaar is tegen welk tarief.</p>
                <div class="text-center">
                    <a href="mailto:info@azurity.nl?subject=Demo Aanvraag" class="btn btn-azure-dark">Demo Aanvragen</a>
                </div>
            </div>
        </div>
        <div class="row m-0 p-5 zIndexOne">
            <div class="col-md-4 offset-md-2 text-center vert-center  mt-5 mb-5 mt-md-0 mb-md-0   ">
                <font-awesome-icon :icon="['far', 'star']" size="3x"  />
                <font-awesome-icon :icon="['far', 'star']" size="3x" />
                <font-awesome-icon :icon="['far', 'star']" size="3x" />
                <font-awesome-icon :icon="['far', 'star']" size="3x" />
                <font-awesome-icon :icon="['far', 'star']" size="3x" />
            </div>
            <div class="col-md-4 text-left ">
                <h3>Wij luisteren...!</h3>
                <p>5-sterren service! Laat direct weten of de professionele dienst voldoet aan de verwachting. Jouw review helpt ons in het aanbod van de beste professionals.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    }
}
</script>

<style scoped>
.img-hover {
    cursor: pointer;
    -webkit-transition: width 1s; /* Safari */
    transition: width 1s;
}
.img-hover:hover {    
    width: 100%;
}
</style>